module.exports = __webpack_public_path__ + "images/d06bfcaa9be3881e90319197e45409bd-Millennials in Travel .png";